export function formatDateShort(asString: string, options: Intl.DateTimeFormatOptions = {}) {
    // 20 Jan
    const parsed = new Date(asString);
    return formatDateObjShort(parsed, options);
}

export function formatDateObjShort(d: Date, options: Intl.DateTimeFormatOptions = {}) {
    // 20 Jan
    return d.toLocaleString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: '2-digit',
        ...options,
    });
}
